import { render, staticRenderFns } from "./contractDel.vue?vue&type=template&id=d8bff486&scoped=true&"
import script from "./contractDel.vue?vue&type=script&lang=js&"
export * from "./contractDel.vue?vue&type=script&lang=js&"
import style0 from "./contractDel.vue?vue&type=style&index=0&id=d8bff486&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8bff486",
  null
  
)

export default component.exports